import React from 'react';
import ModuleTable from 'Components/Core/ModuleTable';
import FormElement from 'Components/Core/Form/FormElement';
import BooleanIcon from 'Components/Core/BooleanIcon';
import BankSyncModal from 'Components/Banking/BankSyncModal';
import './BankAccounts.css';

export default function BankAccounts(props) {

	const x = props.x;
	const wafId = props.id;
	const dialogFormId = "form-" + props.id;

	const [reloadKey, setReloadKey] = React.useState(0);
	const [syncTarget, setSyncTarget] = React.useState(null);
	// null = Schalterzustand noch nicht geladen. Der Zustand selbst lebt als
	// httpOnly-Cookie beim Server (PinStore.inc), hier nur das Abbild fuer die UI.
	const [pinUse, setPinUse] = React.useState(null);

	React.useEffect(() => {
		x.was.axPost('Backend/webapp.php?module=Banking&task=BankingPinSwitch', {}, (result) => {
			if (result.data.returncode === 1) {
				setPinUse(parseInt(result.data.content.enabled, 10) === 1);
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function togglePinUse() {
		const enabled = pinUse ? 0 : 1;
		x.was.axPost('Backend/webapp.php?module=Banking&task=BankingPinSwitch', { enabled: enabled }, (result) => {
			if (result.data.returncode === 1) {
				setPinUse(parseInt(result.data.content.enabled, 10) === 1);
			}
		});
	}

	function forgetAllPins() {
		x.was.axPost('Backend/webapp.php?module=Banking&task=BankingPinForget', {}, (result) => {
			if (result.data.returncode === 1) {
				x.wah.addHint(result.data.content.forgotten + ' gemerkte PIN(s) gelöscht.');
				setReloadKey((current) => current + 1);
			}
		});
	}

	const formFields =
		<React.Fragment>
			<FormElement type="text" x={x} wafId={wafId} id="bankname" mandatory={true} title="Bank" fieldValue="" maxLength="100" />
			<FormElement type="text" x={x} wafId={wafId} id="fintsurl" mandatory={false} title="FinTS-URL (optional)" fieldValue="" maxLength="255" placeholder="Für bekannte Banken automatisch ermittelt" />
			<FormElement type="text" x={x} wafId={wafId} id="loginname" mandatory={true} title="Anmeldename" fieldValue="" maxLength="100" />
			<FormElement type="text" x={x} wafId={wafId} id="iban" mandatory={true} title="IBAN" fieldValue="" maxLength="34" />
			<FormElement type="text" x={x} wafId={wafId} id="accountlabel" mandatory={true} title="Bezeichnung" fieldValue="" maxLength="100" />
			<FormElement type="checkbox" x={x} wafId={wafId} id="disabled" title="Inaktiv" />
		</React.Fragment>

	function afterSync() {
		setSyncTarget(null);
		setReloadKey((current) => current + 1);
	}

	// Table.js ruft onAddColumn(key, value) je Zeile spaltenweise auf, ohne die
	// gesamte Zeile mitzugeben - bankname/accountlabel werden hier zwischen-
	// gespeichert, damit der Sync-Klick spaeter in derselben Zeile darauf
	// zugreifen kann (Reihenfolge entspricht der SQL-Spaltenreihenfolge).
	let rowBankname = '';
	let rowAccountlabel = '';
	let rowPinstored = 0;

	return (
		<React.Fragment>
			<ModuleTable
				id={props.id}
				tableId="id"
				dialogFormId={dialogFormId}
				x={x}
				classes="module-banking-accounts"
				tableClasses="banking-accounts-table"
				title={props.title}
				addDeleteRow={true}
				addTitle="Neue Bankverbindung anlegen"
				formTitle="Bankverbindung"
				module="Banking"
				listTask="BankingConnectionList"
				deleteTask="BankingConnectionDelete"
				reloadKey={reloadKey}
				onAddHeader={(addHeader) => {
					addHeader('Bank');
					addHeader('IBAN');
					addHeader('Bezeichnung');
					addHeader('Letzter Abruf');
					addHeader('PIN gemerkt');
					addHeader('Abrufen');
					addHeader('Inaktiv');
				}}
				onAddColumn={(key, value) => {
					switch (key) {
						case 'connectionid':
							return false;
						case 'bankname':
							rowBankname = value;
							return value;
						case 'iban':
							return value;
						case 'accountlabel':
							rowAccountlabel = value;
							return value;
						case 'lastsyncat':
							return value || 'noch nie';
						case 'pinstored':
							rowPinstored = parseInt(value, 10) === 1;
							return rowPinstored
								? <span className="bi bi-key-fill" title="PIN gemerkt (verschlüsselt in diesem Browser)"></span>
								: '';
						case 'syncicon':
							return (
								<span
									className="bi bi-arrow-repeat module-icon"
									title="Umsätze abrufen"
									onClick={(e) => {
										e.stopPropagation();
										setSyncTarget({ connectionId: value, label: rowBankname + ' - ' + rowAccountlabel, pinStored: rowPinstored });
									}}
								></span>
							);
						case 'disabled':
							return <BooleanIcon value={value} />;
						default:
							return false;
					}
				}}
				onEditRow={(e, rowFields, rowId) => {
					x.waf.setAddSend(wafId, 'id', rowFields.connectionid);
					x.waf.set(wafId, 'bankname', rowFields.bankname);
					x.waf.set(wafId, 'fintsurl', rowFields.fintsurl);
					x.waf.set(wafId, 'loginname', rowFields.loginname);
					x.waf.set(wafId, 'iban', rowFields.iban);
					x.waf.set(wafId, 'accountlabel', rowFields.accountlabel);
					x.waf.set(wafId, 'disabled', rowFields.disabled);
					x.waf.hide(wafId, 'message');
					x.wad[dialogFormId].setTitle("Bankverbindung bearbeiten");
					x.wad[dialogFormId].show(() => { x.waf.focus(wafId, 'bankname') });
				}}
				formFields={formFields}
				formSendTask="BankingConnectionSave"
			/>
			{pinUse !== null &&
				<div className="banking-pin-settings">
					<label>
						<input type="checkbox" checked={pinUse} onChange={togglePinUse} />
						PINs merken erlauben (verschlüsselt, nur dieser Browser)
					</label>
					<button type="button" className="btn" onClick={forgetAllPins}>
						Alle gemerkten PINs vergessen
					</button>
				</div>
			}
			{syncTarget &&
				<BankSyncModal
					x={x}
					connectionId={syncTarget.connectionId}
					accountLabel={syncTarget.label}
					pinUse={pinUse === true}
					pinStored={syncTarget.pinStored}
					onClose={() => setSyncTarget(null)}
					onSuccess={afterSync}
				/>
			}
		</React.Fragment>
	)

};
